/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const teamsSyncRequestSchema = z.object({
  instanceId: z.string().min(1),
  teamType: z.enum(['JIRA_TEAM', 'TEMPO_TEAM', 'ADO_TEAM']),
});
